import React from 'react';
import { useSelector } from 'react-redux';
import ReactAppBuilder from 'src/utils/react-app-builder';
import {
  Wrapper,
  Corner,
  CellWrapper,
  RowWrapper,
  ColumnWrapper
} from './table-grips.style';
import useTableSelectionMap from './useTableSelectionMap';

export default class TableGrips extends ReactAppBuilder {
  constructor ({
    appId,
    element,
    targetNodeSelector,
    gripsSize,
    gutterSize,
    dimensions,
    onGripClick,
    initEditMode,
    onRemoveRow,
    onRemoveColumn,
    onRemoveMouseEnter,
    onRemoveMouseLeave,
    onInsertRow,
    onInsertColumn
  }) {
    super({ appId, targetNodeSelector });

    this.tableElement = element;
    this.gripSize = gripsSize;
    this.gutterSize = gutterSize;
    this.dimensions = dimensions;
    this.onGripClick = onGripClick;
    this.initEditMode = initEditMode;

    this.onRemoveRow = onRemoveRow;
    this.onRemoveMouseEnter = onRemoveMouseEnter;
    this.onRemoveMouseLeave = onRemoveMouseLeave;
    this.onRemoveColumn = onRemoveColumn;
    this.onInsertRow = onInsertRow;
    this.onInsertColumn = onInsertColumn;
  }

  createDOMNode () {
    const container = document.getElementById(this.appId);
    if (container) return container;

    const targetNode = document.querySelector(this.targetNodeSelector);
    const app = document.createElement('div');
    app.id = this.appId;
    app.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    app.style.overflow = 'visible';
    targetNode.appendChild(app);

    this.appNode = document.getElementById(app.id);
    return this.appNode;
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp () {
    super.mountApp(this.App);
  }

  mapProps = () => {
    const zoom = useSelector(state => state.editor.zoom);
    return {
      tableElement: this.tableElement,
      dimensions: this.dimensions,
      gripSize: this.gripSize,
      gutterSize: this.gutterSize,
      borderWidth: 1 / zoom,
      onGripClick: this.onGripClick
    };
  };

  App = (props) => {
    const { gripSize, gutterSize, tableElement, dimensions, borderWidth, onGripClick } = this.mapProps(props);
    const selectionMap = useTableSelectionMap(tableElement);
    const onClickHandler = (event, type, data) => {
      if (INKIVE.EditorFacade.canvas.getMode() === 'textedit') {
        INKIVE.EditorFacade.canvas.runExtensions('endEditing');
      }
      onGripClick(event, type, data);
    };

    return (<Wrapper width={dimensions.width} height={dimensions.height} gripSize={gripSize} gutterSize={gutterSize}>
      <Corner
        isActive={selectionMap.table}
        gripSize={gripSize}
        borderWidth={borderWidth}
        onClick={event => onClickHandler(event, 'corner', null)}
      />

      <RowWrapper gripSize={gripSize} borderWidth={borderWidth}>
        {
          selectionMap.rows.map((row, index) => {
            const isOtherRowActive = selectionMap.rows.some((row, internalIndex) => index !== internalIndex && row.isSelected);
            return <CellWrapper
              key={`row-${index}-${row.size}-${row.isSelected}`}
              type="row"
              size={{ height: `${row.size}%` }}
              isActive={row.isSelected}
              index={index}
              isOtherItemActive={isOtherRowActive}
              gripSize={gripSize}
              borderWidth={borderWidth}
              onClick={event => onClickHandler(event, 'row', index + 1)}
              onAddClick={this.onInsertRow}
              onRemove={this.onRemoveRow}
              onRemoveMouseEnter={this.onRemoveMouseEnter}
              onRemoveMouseLeave={this.onRemoveMouseLeave}
            />;
          })
        }
      </RowWrapper>

      <ColumnWrapper gripSize={gripSize} borderWidth={borderWidth}>
        {
          selectionMap.columns.map((column, index) => {
            const isOtherColumnActive = selectionMap.columns.some((column, internalIndex) => index !== internalIndex && column.isSelected);
            return <CellWrapper
              key={`column-${index}-${column.size}-${column.isSelected}`}
              type="column"
              size={{ width: `${column.size}%` }}
              isActive={column.isSelected}
              index={index}
              isOtherItemActive={isOtherColumnActive}
              gripSize={gripSize}
              borderWidth={borderWidth}
              onClick={event => onClickHandler(event, 'column', index + 1)}
              onAddClick={this.onInsertColumn}
              onRemove={this.onRemoveColumn}
              onRemoveMouseEnter={this.onRemoveMouseEnter}
              onRemoveMouseLeave={this.onRemoveMouseLeave}
            />;
          })
        }
      </ColumnWrapper>

  </Wrapper>);
  };
}
